import React, { Component } from "react";
import SSO from "../../sso";
import config from "../../sso/config";

/**
 * Login Component
 * OIDC callback handler for internal/enterprise users
 */
class Login extends Component {
  componentDidMount() {
    let extUser = localStorage.getItem(config.fetch_details_param);
    
    // After logout or first visit, default to "false" for initial sign-in attempt
    if (extUser === null) {
      extUser = "false";
      localStorage.setItem(config.fetch_details_param, false);
    }
    // Bootstrap session for both internal and external users
    // SSO.signIn() will call fetchDetails() which populates Redux session
    
    SSO.signIn(extUser)
      .then(() => {
        // Sign-in successful
      })
      .catch((err) => {
        console.error('SSO sign-in error:', err);
      });
  }

  render() {
    return null;
  }
}

export default Login;
